import { ConversationRatedEntry } from 'lib-shared-legacy-types';

export function getRatingTypeText(
  ratingType: ConversationRatedEntry['rating_type'],
): string {
  switch (ratingType) {
    case 'Nps':
      return 'NPS';
    case 'ThumbsUpOrDown':
      return 'Thumbs up or down';
    case 'Csat':
      return 'CSAT';
    default:
      return 'Unknown type';
  }
}
